module.exports = __webpack_public_path__ + "img/watch-2.dcc20ccd.png";